import { render } from "./ProjectData.vue?vue&type=template&id=5acab666&scoped=true"
import script from "./ProjectData.vue?vue&type=script&lang=js"
export * from "./ProjectData.vue?vue&type=script&lang=js"

import "./ProjectData.vue?vue&type=style&index=0&id=5acab666&lang=sass&scoped=true"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acab666"]])

export default __exports__